import { FormBase } from 'core/components';

export default class PumpsNoteEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'pumpsNote',
                    label: "PUMPS.LANDING.FACILITY_NOTE_LABEL",
                    placeholder: "PUMPS.LANDING.FACILITY_NOTE_PLACEHOLDER",
                    rules: 'string'                 
                }
            ],
        };
    }
}
